import React from 'react';
import useFeatureFlags from '../hooks/useFeatureFlags';
import './MarketCompare.css';

// Sprint R2 — "X% below market" trust badge. Renders ONLY when:
//   - the market_compare_enabled flag is on,
//   - we have a market price strictly above our price (real savings), and
//   - the market data isn't stale (default 7-day freshness window).
// Otherwise it renders nothing, so call sites can drop it in unconditionally.
//
// variant: 'badge'  → compact inline pill (product cards)
//          'detail' → labelled block ("Market $X · 12% below")  (product page)
const FRESH_MS = 7 * 24 * 60 * 60 * 1000;

export default function MarketCompare({ price, marketPrice, marketPriceAt, variant = 'badge' }) {
  const flags = useFeatureFlags();
  if (flags.market_compare_enabled === false) return null;

  const p = Number(price);
  const m = Number(marketPrice);
  if (!Number.isFinite(p) || !Number.isFinite(m) || m <= p || p <= 0) return null;

  // Freshness guard — never anchor to a price we haven't refreshed in a week.
  if (marketPriceAt) {
    const ts = new Date(marketPriceAt).getTime();
    if (Number.isFinite(ts) && Date.now() - ts > FRESH_MS) return null;
  }

  const pct = Math.round((1 - p / m) * 100);
  if (pct < 1) return null; // sub-1% isn't worth a badge

  if (variant === 'detail') {
    return (
      <div className="market-compare market-compare--detail">
        <span className="market-compare__market">Market ${m.toFixed(2)}</span>
        <span className="market-compare__pill">{pct}% below market</span>
      </div>
    );
  }
  return (
    <span className="market-compare market-compare--badge" title={`Market price $${m.toFixed(2)}`}>
      {pct}% below market
    </span>
  );
}
